module.exports = __webpack_public_path__ + "media/images/session/edit-password-0df92a8debb88d3a2dd2db331228393f.svg";